import { Paper, Box, Typography, TextField, Button } from "@mui/material";
import DraftsIcon from "@mui/icons-material/Drafts";
import { blue } from "@mui/material/colors";
import type { IZnsTemplate } from "modules/outbound-message/types/znsTemplate";

export interface NewCampaignFormProps {
  /** Currently selected ZNS template; shown in the Template field. */
  selectedTemplate?: IZnsTemplate | null;
  /** Called when user clicks "Select ZNS template" to open the template picker. */
  onSelectTemplateClick?: () => void;
  campaignName: string;
  onCampaignNameChange: (name: string) => void;
}

/**
 * Form for creating a new ZNS campaign: campaign name and template selection.
 */
export const NewCampaignForm = ({
  selectedTemplate = null,
  onSelectTemplateClick,
  campaignName,
  onCampaignNameChange,
}: NewCampaignFormProps) => {
  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Box sx={{ py: 1.5, px: 2, backgroundColor: blue[50], width: "100%" }}>
        <Typography variant="body1" fontWeight="bold">
          Create new ZNS campaign
        </Typography>
        <Typography variant="body2" color="text.secondary">
          The campaign name should be between 10 to 80 characters long.
        </Typography>
      </Box>
      <Box
        sx={{
          p: 2,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <TextField
          label="ZNS Campaign name"
          fullWidth
          variant="standard"
          value={campaignName}
          onChange={(e) => onCampaignNameChange(e.target.value)}
        />
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: "row",
            width: "100%",
          }}
        >
          <TextField
            label="ZNS Template"
            sx={{ flex: selectedTemplate ? 3 : 1, textTransform: "uppercase" }}
            variant="filled"
            disabled
            value={selectedTemplate?.templateName ?? ""}
            placeholder="Select a template"
          />
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: 15, flex: 1, gap: 1 }}
            onClick={onSelectTemplateClick}
          >
            {selectedTemplate ? (
              "EDIT"
            ) : (
              <>
                <DraftsIcon />
                Select ZNS template
              </>
            )}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};
